if (!window.Eurus.loadedScript.includes('product-sibling.js')) {
    window.Eurus.loadedScript.push('product-sibling.js');

    requestAnimationFrame(() => {
        document.addEventListener("alpine:init", () => {
            Alpine.data("xProductSibling", (sectionId, isProductPage, redirect) => ({
                cachedResults: [],
                updateProductInfo(url) {
                    if (redirect) {
                        window.location.href = url;
                        return
                    }
                    const link = isProductPage ? `${url}` : `${url}?section_id=${sectionId}`;

                    if (this.cachedResults[link]) {
                        const html = this.cachedResults[link];
                        this._handleSwapProduct(html);
                    } else {
                        fetch(link)
                            .then((response) => response.text())
                            .then((responseText) => {
                                const html = new DOMParser().parseFromString(responseText, 'text/html');
                                this._updateTitle(html);
                                this._handleSwapProduct(html);
                                this.cachedResults[link] = html;
                            })
                    }
                    this._updateURL(url);
                },
                changeSelectOption(event) {
                    const input = event.target.selectedOptions[0];
                    const targetUrl = input.dataset.productUrl;
                    this.updateProductInfo(targetUrl);
                },
                _updateURL(url) {
                    if (!isProductPage) return;
                    window.history.replaceState({}, '', `${url}`);
                },
                _updateTitle(html) {
                    if (!isProductPage) return;
                    document.querySelector('head title').textContent = html.querySelector('.product-title').textContent;
                    const destination = document.querySelector('#breadcrumbs--' + sectionId);
                    const source = html.querySelector('#breadcrumbs--' + sectionId);
                    if (source && destination) destination.innerHTML = source.innerHTML;
                },
                _handleSwapProduct(html) {
                    const destination = isProductPage ? document.querySelector('.main-product') : document.querySelector('.x-product-' + sectionId);
                    const source = isProductPage ? html.querySelector('.main-product') : html.querySelector('.x-product-' + sectionId);
                    if (source && destination) destination.innerHTML = source.innerHTML;
                    
                    // Update nutritional info section if it exists
                    this._updateNutritionalInfo(html);
                },
                _updateNutritionalInfo(html) {
                    // Option 1: Full section swap (current implementation)
                    const nutritionalDestination = document.querySelector('.section-nutritional-info');
                    const nutritionalSource = html.querySelector('.section-nutritional-info');
                    if (nutritionalSource && nutritionalDestination) {
                        nutritionalDestination.innerHTML = nutritionalSource.innerHTML;
                        return;
                    }
                    
                    // Option 2: Targeted nutritional data update (alternative approach)
                    this._updateNutritionalData(html);
                },
                _updateNutritionalData(html) {
                    // Find the new product's nutrition data from the fetched HTML
                    const newNutritionScript = html.querySelector('[id^="nutrition-data-"]');
                    if (!newNutritionScript) return;
                    
                    // Find the current nutrition panel
                    const currentNutritionScript = document.querySelector('[id^="nutrition-data-"]');
                    if (!currentNutritionScript) return;
                    
                    // Update the nutrition data
                    currentNutritionScript.textContent = newNutritionScript.textContent;
                    
                    // Trigger Alpine.js component refresh
                    const nutritionPanel = document.querySelector('[x-data*="nutritionPanel"]');
                    if (nutritionPanel && nutritionPanel._x_dataStack) {
                        const component = nutritionPanel._x_dataStack[0];
                        if (component && component.loadNutritionData) {
                            component.loadNutritionData();
                            component.init();
                        }
                    }
                }

            }));
        });
    });
}